import {createContext, useContext} from 'react'
import {triggerReloadInterface} from '../global'

interface ContactsResponse {
  data: Contact[]
}

interface Contact  {
  id: number
  first_name?: string
  last_name?: string
  email: string
  tags: ContactTag[]
  number?: string
  note: any
  mobile: any
  country: any
  street?: string
  companyName?: string
  zipCode: any
  city: any
  unsubscribed_at?: string
  created_at: string
  updated_at: string
}

interface ContactTag {
  id: number
  name: string
  mode_import: string
  created_at: string
  update_at: string
}

interface ContactsContextInterface extends ContactsResponse, triggerReloadInterface {
}

interface Base {
  id?: number;
  created_at: string;
  date: string;
  status: string;
  type: "form" | "call";
}

interface IFormType extends Base {
  sent_at?: string;
  trait_at?: string | null;
  notes?: string | null;
  form: string;
  type: "form";
}

interface ICallType extends Base {
  called_at: string;
  callFrom: string;
  transferTo: string;
  duration: number;
  type: "call";
}

type CallItemType = IFormType | ICallType;

const initialContactTag: ContactTag = {
  id: -1,
  name: '',
  mode_import: '',
  created_at: '',
  update_at: ''
};

const initialContact: Contact = {
  id: -1,
  first_name: '',
  last_name: '',
  email: '',
  tags: [initialContactTag],
  number: '',
  note: null,
  mobile: null,
  country: null,
  street: '',
  companyName: '',
  zipCode: null,
  city: null,
  unsubscribed_at: '',
  created_at: '',
  updated_at: ''
};

const ContactsContext = createContext<ContactsContextInterface>({
  data: [initialContact],
  reloadKey: 0,
  triggerReload: () => {}
})

const useContactsContext = () => useContext(ContactsContext)

const initialContactsResponse: Contact[] = [
  initialContact
]

export {
  initialContactTag,
  initialContact,
  ContactsContext,
  useContactsContext,
  initialContactsResponse
}

export type {
  ContactsResponse,
  Contact,
  ContactTag,
  CallItemType
}